module.exports = "<header-main></header-main>\n<!-- LEFT SIDEBAR -->\n<!-- \n<div class=\"sidebar left\">\n    <loader loaderName=\"socket\"></loader>\n</div> -->\n<!-- CONTENT -->\n<div class=\"content\">\n    <nav-main></nav-main>\n    <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/app/main/main.component.html
// module id = ../../../../../src/app/main/main.component.html
// module chunks = 1